import styled from "styled-components";
import {Button, Input, Alert, List} from "@chakra-ui/react";
import {FaSearch} from "react-icons/fa";
import {Field} from "../../components/ui/field";
import {responsive} from "../../media-quries";
import {useCallback, useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router";
import {Container, debounce, Link, Miejscowosc} from "./address-search";
import {AsyncSelect} from "chakra-react-select";
import {fetchCities, getCityById} from "../../services/services";
import {useUpdateQueryParam} from "../../utils/navigation";
import {parseCityOption} from "../../utils/select-options";

const ParcelNumber = styled(Field)`
  flex-basis: calc(50% - 8px);

  ${responsive.sm`
  flex-basis: 100%;
  `}
`;

const Szukaj = styled(Button)`
  flex: 1;

  ${responsive.md`
  margin-top: 24px;
  `}

  ${responsive.sm`
  margin-top: 0;
  `}
`;

function ParcelNumberSearch({ searching }) {
    const [city, setCity] = useState(null);
    const [parcelNumber, setParcelNumber] = useState(null);
    const [isCityMenuOpen, setIsCityMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [cityOptions, setCityOptions] = useState([]);
    const [searchParams] = useSearchParams();
    const parcelNumberParam = searchParams.get("parcelNumber");
    const cityParam = searchParams.get("city");

    const getCity = (id) => {
        getCityById(id)
            .then((result) => {
                if (result?.result) {
                    setCity(parseCityOption(result.result))
                }
            })
    };

    useEffect(() => {
        if (parcelNumberParam) {
            setParcelNumber(parcelNumberParam)
        }

        if (cityParam) {
            getCity(cityParam);
        }
    }, [parcelNumberParam, cityParam])

    const searchCities = async (inputValue) => {
        if (!inputValue || inputValue.length < 3) return [];
        try {
            const response = await fetchCities(inputValue);
            const results = response.result.map(parseCityOption);
            setCityOptions(results);
            setIsCityMenuOpen(results.length > 0);
            return results;
        } catch (error) {
            console.error("Error fetching cities:", error);
            return [];
        }
    };

    const debouncedFetchCities = useCallback(debounce(searchCities, 500), []);
    const updateQueryParams = useUpdateQueryParam();

    return <Container>
        <Miejscowosc label="Miejscowość" required helperText="Zacznij pisać i wybierz z listy">
            <AsyncSelect
                className="select"
                value={city}
                onChange={(val) => {
                    setCity(val);
                    setParcelNumber('');
                    setIsCityMenuOpen(false);
                }}
                variant="searchBar"
                placeholder="Zacznij pisać..."
                selectedOptionStyle="check"
                noOptionsMessage={() => "Brak wyników..."}
                cacheOptions
                loadOptions={debouncedFetchCities}
                isClearable
                onBlur={() => setIsCityMenuOpen(false)}
                menuIsOpen={isCityMenuOpen}
                onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                        setIsCityMenuOpen(inputValue.length >= 3 && cityOptions.length > 0);
                    }
                }}
            />
        </Miejscowosc>
        <ParcelNumber label="Numer działki">
            <Input value={parcelNumber} disabled={!city} onChange={(e) => setParcelNumber(e.target.value)} placeholder="Podaj numer działki" />
        </ParcelNumber>
        <Szukaj variant="solid"
                disabled={!city || !parcelNumber || searching}
                onClick={() => {
                    let params = `searchBy=number&city=${city.value}&parcelNumber=${parcelNumber}`;

                    navigate(`/szukaj?${params}`);
                }}>
            <FaSearch /> Szukaj księgi wieczyste
        </Szukaj>
        <Alert.Root colorPalette="accent">
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>Jak szukać po numerze działki:</Alert.Title>
                <Alert.Description>
                    <List.Root>
                        <List.Item>Zacznij wpisywać nazwę miejscowości i wybierz pozycję z dostępnych na liście propozycji a nastepnie uzupełnij numer działki</List.Item>
                        <List.Item>Jeśli znasz pełny identyfikator działki możesz skorzystać także z wyszukiwania po identyfikatorze</List.Item>
                        <List.Item>Jeśli dla wskazanych kryteriów nie udało Ci się znaleść szukanej księgi spróbuj wyszukiwania{' '}
                            <Link onClick={() => updateQueryParams('searchBy', 'address')}>
                                po adresie
                            </Link>{' '}
                            lub po{' '}
                            <Link onClick={() => updateQueryParams('searchBy', 'id')}>
                                po identyfikatorze działki
                            </Link>
                        </List.Item>
                    </List.Root>
                </Alert.Description>
            </Alert.Content>
        </Alert.Root>
    </Container>
}

export default ParcelNumberSearch;
